function CloseIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 10 11" fill="none" {...props}>
			<path
				d="M9.78 1.782A.75.75 0 008.72.723L5.003 4.441 1.283.721A.75.75 0 00.223 1.78L3.94 5.496l-3.72 3.72a.75.75 0 001.059 1.059L4.996 6.56l3.72 3.72a.75.75 0 001.059-1.06L6.06 5.505l3.72-3.72z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default CloseIcon;
